import React, { SetStateAction, useEffect, useState } from "react";
import { Modal } from "react-responsive-modal";
import "react-responsive-modal/styles.css";
import styled from "styled-components";
import "../../styles/CustomModal.css";

import {
  optionGroupType,
  optionType,
  ProductType,
} from "../../controller/StoreController";
import { getOptionName, getOptionTypeName } from "../../utils/util";
import { useRecoilState } from "recoil";
import { langState, langText } from "../../recoil/lang";

import { useToast } from "../../controller/ToastController";
import moment from "moment-timezone";
import { InputRentalType } from "../../controller/OrderController";

type Props = {
  isVisible: boolean;
  setVisible: (bVisible: boolean) => void;
  option: optionGroupType[];
  setSelectedProduct: any;
  RenderProductDetail: any;
  selectedOption: number[][];
  setSelectedOption: React.Dispatch<SetStateAction<number[][]>>;
  addCart: (rentalTime?: any) => any;
  resetTimer: any;
  selectedProduct: ProductType;
  rentalTime: InputRentalType;
  setRentalTime: (rentalTime: InputRentalType) => void;
};

// 옵션 선택 화면
const RenderOptionList = (oProps: any) => {
  const showToast = useToast();

  const { selectedOption, setSelectedOption, lang } = oProps;
  const option: optionGroupType[] = oProps.option;

  // 필수 1개
  const handleRadioChange = (
    item: optionType,
    index: number,
    optionIndex: number
  ) => {
    let temp = [...selectedOption];
    temp[index] = [optionIndex];
    setSelectedOption(temp);
  };
  // 필수 여러개 or 최대선택
  const handleCheckboxChange = (
    item: optionType,
    index: number,
    optionIndex: number
  ) => {
    let temp = [...selectedOption];

    const indexToRemove = temp[index].indexOf(optionIndex);
    if (indexToRemove !== -1) {
      temp[index].splice(indexToRemove, 1);
    } else {
      if (option[index].option_input_max <= temp[index].length) {
        if (option[index].option_input_min === 0) {
          showToast(
            langText.optionModal_title_Maximum[lang] +
              option[index].option_input_max +
              langText.optionModal_detail_choice[lang],
            "error"
          );
        } else {
          showToast(
            langText.optionModal_title_Required[lang] +
              option[index].option_input_max +
              langText.optionModal_detail_choice[lang],
            "error"
          );
        }
        return;
      } else {
        temp[index].push(optionIndex);
      }
    }

    setSelectedOption(temp);
  };
  return (
    <div className="optionListWrap">
      {option?.map((optionGroup: optionGroupType, index: number) => {
        return (
          optionGroup.option_list.length > 0 && (
            <div className="optionList">
              <div className="optionName">
                <h3>{getOptionTypeName(optionGroup, lang)}</h3>

                {/* 필수1개 - radio */}
                {((optionGroup.option_input_min === 0 &&
                  optionGroup.option_input_max === 0) ||
                  (optionGroup.option_input_min === 1 &&
                    optionGroup.option_input_max === 1)) && (
                  <span className="require">
                    ({langText.optionModal_title_Required[lang]}1
                    {langText.title_detail_count[lang]})
                  </span>
                )}
                {/* 필수1개 이상 - checkbox */}
                {optionGroup.option_input_min !== 0 &&
                  optionGroup.option_input_max > 1 && (
                    <>
                      <span className="require">
                        ({langText.optionModal_title_Required[lang]}
                        {optionGroup.option_input_min}
                        {langText.title_detail_count[lang]})
                      </span>
                      {optionGroup.option_input_min !==
                        optionGroup.option_input_max && (
                        <span className="noneRequire">
                          ({langText.optionModal_title_Maximum[lang]}
                          {optionGroup.option_input_max}
                          {langText.title_detail_count[lang]})
                        </span>
                      )}
                    </>
                  )}
                {/* 최대 선택 이상 - checkbox */}
                {optionGroup.option_input_min === 0 &&
                  optionGroup.option_input_max > 0 && (
                    <span className="noneRequire">
                      ({langText.optionModal_title_Maximum[lang]}{" "}
                      {optionGroup.option_input_max}
                      {langText.title_detail_count[lang]})
                    </span>
                  )}
              </div>
              <div className="optionButtonWrap">
                {optionGroup?.option_list.map(
                  (option: optionType, optionIndex: number) => {
                    const optionId = `option_${index}_${optionIndex}`;
                    const requireType =
                      (optionGroup.option_input_min === 0 &&
                        optionGroup.option_input_max === 0) ||
                      (optionGroup.option_input_min === 1 &&
                        optionGroup.option_input_max === 1);
                    const inputName = `${requireType ? "require" : ""}${index}`;
                    const isDisabled = option.is_soldout === 1;
                    const isSelected =
                      selectedOption[index].includes(optionIndex);

                    return requireType ? (
                      // 필수 1개
                      <div
                        key={optionIndex}
                        className={`optionButton ${
                          isSelected ? "active" : ""
                        } ${isDisabled ? "disabled" : ""}`}
                      >
                        <label htmlFor={optionId}>
                          <input
                            type="radio"
                            id={optionId}
                            name={inputName}
                            value={option.option_id}
                            checked={isSelected}
                            disabled={isDisabled}
                            onChange={() => {
                              if (!isDisabled)
                                handleRadioChange(option, index, optionIndex);
                            }}
                          />
                          <h3>{getOptionName(option, lang)}</h3>
                          <h3 className="optionPrice">
                            {option.option_price_nrm}원
                          </h3>
                        </label>
                      </div>
                    ) : (
                      // 필수 여러개 또는 최대선택
                      <div
                        key={optionIndex}
                        className={`optionButton ${
                          isSelected ? "active" : ""
                        } ${isDisabled ? "disabled" : ""}`}
                      >
                        <label htmlFor={optionId}>
                          <input
                            type="checkbox"
                            id={optionId}
                            name={inputName}
                            value={option.option_id}
                            checked={isSelected}
                            disabled={isDisabled}
                            onChange={() => {
                              if (!isDisabled)
                                handleCheckboxChange(
                                  option,
                                  index,
                                  optionIndex
                                );
                            }}
                          />
                          <h3>{getOptionName(option, lang)}</h3>
                          <h3 className="optionPrice">
                            {option.option_price_nrm}원
                          </h3>
                        </label>
                      </div>
                    );
                  }
                )}
              </div>
            </div>
          )
        );
      })}
    </div>
  );
};

const RenderRentalList = (oProps: any) => {
  const { rentalTime, setRentalTime, lang, selectedProduct } = oProps;

  const timeList =
    selectedProduct &&
    selectedProduct.available_start_at &&
    selectedProduct.available_finish_at
      ? Array.from(
          {
            length:
              Number(selectedProduct.available_finish_at.slice(0, 2)) <
              Number(selectedProduct.available_start_at.slice(0, 2))
                ? Number(selectedProduct.available_finish_at.slice(0, 2)) +
                  24 -
                  Number(selectedProduct.available_start_at.slice(0, 2))
                : Number(selectedProduct.available_finish_at.slice(0, 2)) -
                    Number(selectedProduct.available_start_at.slice(0, 2)) ===
                  24
                ? 24
                : Number(selectedProduct.available_finish_at.slice(0, 2)) -
                  Number(selectedProduct.available_start_at.slice(0, 2)),
          },
          (_, i) =>
            `${String(
              (Number(selectedProduct.available_start_at.slice(0, 2)) + i) % 24
            ).padStart(2, "0")}:00`
        )
      : [];

  const getAvailableDate = () => {
    const dateList = [];
    for (let i = 1; i < 4; i++) {
      const nextDate = new Date();
      nextDate.setDate(nextDate.getDate() + i);
      dateList.push(moment(nextDate).format("MM-DD"));
    }
    return dateList;
  };

  const checkRentalTime = (optionTypeName: string, optionName: string) => {
    return (
      rentalTime.option_type_name === optionTypeName &&
      rentalTime.option_name === `${optionTypeName} ${optionName}`
    );
  };

  const onChangeRentalTime = (optionTypeName: string, optionName: string) => {
    console.log("option", optionTypeName, optionName);
    setRentalTime({
      option_type_name: optionTypeName,
      option_name: `${optionTypeName} ${optionName}`,
    });
  };

  return (
    <div className="optionListWrap rental">
      <div className="optionList">
        <div className="optionName">
          <h3>사용 시작 시간을 선택해주세요</h3>
        </div>
        <div className="rentalButtonWrap">
          <div
            className={`optionButton rental ${
              checkRentalTime(moment(new Date()).format("MM-DD"), "즉시대여")
                ? "active"
                : ""
            }`}
          >
            <label>
              <input
                type="radio"
                name={"즉시대여"}
                value={`즉시대여`}
                checked={checkRentalTime(
                  moment(new Date()).format("MM-DD"),
                  "즉시대여"
                )}
                onChange={() =>
                  onChangeRentalTime(
                    moment(new Date()).format("MM-DD"),
                    "즉시대여"
                  )
                }
              />
              <h3>즉시대여</h3>
            </label>
          </div>
        </div>
      </div>
      {getAvailableDate().map((item, index) => (
        <div className="optionList" key={index}>
          <div className="optionName">
            <h3>{item}</h3>
          </div>
          <div className="rentalButtonWrap">
            {timeList.map((time: string, timeIndex: number) => (
              <div
                key={timeIndex}
                className={`optionButton rental ${
                  checkRentalTime(item, time) ? "active" : ""
                }`}
              >
                <label htmlFor={`${index}_${timeIndex}`}>
                  <input
                    type="radio"
                    id={`${index}_${timeIndex}`}
                    name={time}
                    value={`${time}`}
                    checked={checkRentalTime(item, time)}
                    onChange={() => onChangeRentalTime(item, time)}
                  />
                  <h3>{time}</h3>
                </label>
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
};

const RentalOptionModal = ({
  isVisible,
  setVisible,
  option,
  setSelectedProduct,
  RenderProductDetail,
  selectedOption,
  setSelectedOption,
  addCart,
  resetTimer,
  selectedProduct,
  rentalTime,
  setRentalTime,
}: Props) => {
  const showToast = useToast();
  const [lang, setLang] = useRecoilState<number>(langState);

  // 옵션 초기화
  const optionReset = () => {
    // setSelectedOption(
    //   option?.map((prdOption) =>
    //     (prdOption.option_input_max === 0 &&
    //       prdOption.option_input_min === 0) ||
    //     prdOption.option_input_min === 1
    //       ? [0]
    //       : []
    //   )
    // );
    setRentalTime({
      option_type_name: "",
      option_name: "",
    });
  };

  const addCartRentalItem = () => {
    // if (rentalTime.option_name.length > 0) {
    addCart();
    // } else {
    // showToast("사용 시작 시간을 선택해주세요", "error");
    // }
  };

  // 초기화 버튼
  const onResetOption = () => {
    optionReset();
    setVisible(false);
  };
  // 옵션 닫기 버튼
  const onCloseModal = () => {
    setVisible(false);
  };

  useEffect(() => {
    if (!isVisible) {
      setSelectedOption([]);
      setSelectedProduct([]);
    }
  }, [isVisible]);

  useEffect(() => {
    optionReset();
  }, [option]);

  if (!isVisible || !option) {
    return null;
  }

  return (
    <Modal
      open={isVisible}
      onClose={onCloseModal}
      center
      classNames={{
        overlay: "optionCustomOverlay",
        modal: "optionCustomModal",
      }}
      showCloseIcon={false}
      animationDuration={150}
    >
      <Style>
        <div onTouchStart={resetTimer} onScrollCapture={resetTimer}>
          <div className="optionWrap">
            <div className="optionTitle">
              <h2>{langText.optionModal_title_optionSelect[lang]}</h2>
              <button onClick={onCloseModal}>
                <img
                  src={`${process.env.PUBLIC_URL}/knockknock/svg/optionClose.svg`}
                  alt="옵션닫기"
                />
              </button>
            </div>
            <RenderProductDetail />
            {option.length > 0 && (
              <RenderOptionList
                option={option}
                selectedOption={selectedOption}
                setSelectedOption={setSelectedOption}
                lang={lang}
              />
            )}
            {/* <RenderRentalList
              rentalTime={rentalTime}
              setRentalTime={setRentalTime}
              lang={lang}
              selectedProduct={selectedProduct}
            /> */}
          </div>
          <div className="modalFooter">
            <button className="resetOptonButton" onClick={onResetOption}>
              <h2>{langText.optionModal_button_ClearAll[lang]}</h2>
            </button>
            <button onClick={addCartRentalItem}>
              <h2>{langText.optionModal_button_AddToCart[lang]}</h2>
            </button>
          </div>
        </div>
      </Style>
    </Modal>
  );
};

export default RentalOptionModal;

const Style = styled.div`
  .optionTitle {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 25px 21px 25px 45px;

    h2 {
      font-size: 24px;
      font-weight: 300;
      color: #fff;
    }
  }

  /* 옵션 상세 설명 */
  .productDetailWrap {
    width: 100%;
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    padding: 0 45px;
    height: 12vh;

    .detailImgWrap {
      flex: 0 0 32%;

      img {
        width: 100%;
        height: 12vh;
      }
    }
    .detailTextWrap {
      flex: 0 0 65%;
      max-width: 65%;
      height: 100%;

      p {
        margin: 15px 0 0 0;
        font-size: 16px;
        font-weight: 400;
        color: #a7a7a7;
        line-height: 24px;
        word-break: keep-all;
        overflow-y: auto;
        max-height: 8vh;
      }
    }
    .detailImg {
      width: 100%;
      border-radius: 10px;
    }
  }
  .detailTextTitle {
    text-align: left;
    width: 100%;

    .detailName {
      max-height: 130px;
      margin-bottom: 16px;
      overflow-y: scroll;
    }
  }

  /* 옵션리스트 */
  .optionListWrap {
    margin: 24px 0 0 0;
    padding: 20px 45px;
    overflow-y: auto;
    border-top: 1px solid #555;
  }
  .optionName {
    margin-bottom: 6px;
    display: flex;
    align-items: center;
    h3 {
      font-size: 16px;
      font-weight: 400;
      color: #e5e5e5;
    }
    span {
      margin-left: 4px;
      font-size: 16px;
      font-weight: 400;
    }
    .require {
      color: #d14848;
    }
    .noneRequire {
      color: #327ad0;
    }
  }
  .optionButtonWrap {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    margin-bottom: 20px;
  }
  .optionButton {
    flex: 0 0 24%;
    margin-bottom: 0.5%;
    min-width: 129px;
    margin: 0.5%;
    background: #343434;
    border: 2px solid #e5e5e5;
    padding: 18px;
    border-radius: 10px;

    h3 {
      font-size: 16px;
      font-weight: 600;
      line-height: 22px;
      color: #e5e5e5;
    }
    .optionPrice {
      margin-top: 28px;
    }
    label {
      display: flex;
      flex-direction: column;
      height: 100%;
      justify-content: space-between;
    }
  }
  label input {
    display: none;
  }
  .disabled {
    background: #656565;
    border-color: #656565;

    h3 {
      color: #979797;
    }
  }
  .optionButton.active {
    background: #40977f;
    border: 2px solid #fff;

    h3 {
      color: #fff;
    }
  }

  .optionListWrap.rental {
    border-top: none;
  }
  .optionButton.rental {
    flex: none;
    min-width: 110px;
    max-width: 110px;
    padding: 18px 0;
    border-radius: 10px;
    text-align: center;
  }
  .rentalButtonWrap {
    display: flex;
    overflow-x: auto;
    justify-content: flex-start;
    margin-bottom: 20px;
  }
  .optionButton.inactive {
    background: #979797;
    border: 2px solid #979797;

    h3 {
      color: #fff;
    }
  }

  .modalFooter {
    width: 100%;
    position: sticky;
    bottom: 0;
    padding: 34px 45px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-top: 1px solid #555555;
    background-color: #343434;

    button {
      width: 50%;
      margin: 0 5px;
      padding: 17px 0;
      border-radius: 10px;
      background: #4dd2ae;
      border: 1px solid #4dd2ae;
      outline: none;

      h2 {
        color: #fff;
        font-weight: 600;
        font-size: 24px;
      }
    }
    .resetOptonButton {
      background: #343434;
      border: 1px solid #777777;
    }
  }
`;
